import { GptConfiguration, IGptConfiguration } from '../../EnterpriseGPTApi/EnterpriseGPTApiV1Client';

export interface IGptConfigurationEx extends IGptConfiguration {
    numberOfChats?: number;
    isShared?: boolean;
}

export class GptConfigurationEx extends GptConfiguration implements IGptConfigurationEx {
    numberOfChats?: number;
    isShared?: boolean;

    constructor(data?: IGptConfigurationEx) {
        super(data);
        if (data) {
            this.numberOfChats = data.numberOfChats;
            this.isShared = data.isShared;
        }
    }

    override init(_data?: any): void {
        super.init(_data);
        if (_data) {
            this.numberOfChats = _data["numberOfChats"];
            this.isShared = _data["isShared"];
        }
    }

    static override fromJS(data: any): GptConfigurationEx {
        data = typeof data === 'object' ? data : {};
        const result = new GptConfigurationEx();
        result.init(data);
        return result;
    }

    override toJSON(data?: any): any {
        data = super.toJSON(data);
        data["numberOfChats"] = this.numberOfChats;
        data["isShared"] = this.isShared;
        return data;
    }

    override clone(): GptConfigurationEx {
        const json = this.toJSON();
        const result = new GptConfigurationEx();
        result.init(json);
        return result;
    }
}
